// Mapbox configuration
// TODO: Remplacez 'VOTRE_TOKEN_MAPBOX_ICI' par votre token Mapbox public (pk.xxx)

// the default public key with no url restrictions, to use fo local dev only
// export const MAPBOX_TOKEN =
//   "pk.eyJ1IjoiaGFtemEtdGhlbWF1bCIsImEiOiJjbWhqOGU3M2IxYWs3MmtyNDNqa3RoNTB2In0.4kTQ83vJrkNPyCa_nzpSDw";

// the secure key with url restrictions, not working in local dev, should work on deployed app and on Lovable
export const MAPBOX_TOKEN =
    "pk.eyJ1IjoiaGFtemEtdGhlbWF1bCIsImEiOiJjbWkzYXNmNGIxdzBoMmpzZmJycXp1aWd1In0.66S8JBFNfTE_gHNwTB6eog";

export const MAPBOX_STYLES = {
  streets: "mapbox://styles/mapbox/streets-v12",
  light: "mapbox://styles/mapbox/light-v11",
  dark: "mapbox://styles/mapbox/dark-v11",
  satellite: "mapbox://styles/mapbox/satellite-streets-v12",
} as const;

export const DEFAULT_STYLE = MAPBOX_STYLES.streets;

export const MAP_CONFIG = {
  defaultZoom: 12,
  minZoom: 2,
  maxZoom: 18,
  defaultCenter: [2.3522, 48.8566] as [number, number], // Paris
} as const;

export const ROUTE_CONFIG = {
  color: "#0880AE",
  width: 4,
  opacity: 0.8,
} as const;

export const MARKER_COLORS = {
  pickup: "#14A38B",
  delivery: "#FF7171",
  tracking: "#0880AE",
  current: "#FFBF07",
} as const;
